import {
  DTWeightedNode,
  WeightedNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {formatOutputHeader, getBaseHeader, getDestinationPhrase, sortOutputsByType} from './utils';

function getWeightPercent(weight: number, sumWeights: number): number {
  if (sumWeights <= 0) return 0;

  return Math.round((weight / sumWeights) * 100);
}

export function weightedCardToText(
  card: DTWeightedNode,
  mode: 'short' | 'full',
  fallbackCreativeNodeId?: number,
): string {
  const header = getBaseHeader(card);
  const purpose = `Purpose: Select random output${
    card.shouldSplitAudience ? ' with audience split' : ''
  }.`;
  const outputs = card.outputs as WeightedNodeOutputData[];
  const sortedOutputs = sortOutputsByType(outputs);
  const sumWeights = outputs.reduce((sum, output) => sum + (output.weight ?? 0), 0);

  const outputLines =
    mode === 'full'
      ? sortedOutputs.map((output, index) => {
          const outputHeader = formatOutputHeader(index, output);
          const dest = getDestinationPhrase(output.nodeId, fallbackCreativeNodeId, output.type);
          const isUnconnected = !output.nodeId;
          const weight = output.weight ?? 0;
          const percent = getWeightPercent(weight, sumWeights);
          const weightPart = `${percent}% of traffic (weight: ${weight})`;
          const suffix = isUnconnected
            ? `${dest}, defined for ${weightPart}`
            : `${dest} - ${weightPart}`;

          return `${outputHeader} ${suffix}`;
        })
      : sortedOutputs.map((output, index) => {
          const outputHeader = formatOutputHeader(index, output);
          const dest = getDestinationPhrase(output.nodeId, fallbackCreativeNodeId, output.type);

          return `${outputHeader} ${dest}`;
        });

  const audienceSplitLine =
    mode === 'full' ? [`Audience Split: ${card.shouldSplitAudience ? 'True' : 'False'}`] : [];
  const purposeLine = mode === 'short' ? purpose : null;

  return [header, ...audienceSplitLine, purposeLine, ...outputLines].filter(Boolean).join('\n');
}
